import { render, staticRenderFns } from "./PostsGrid.vue?vue&type=template&id=25ae76aa&scoped=true&"
import script from "./PostsGrid.vue?vue&type=script&lang=js&"
export * from "./PostsGrid.vue?vue&type=script&lang=js&"
import style0 from "./PostsGrid.vue?vue&type=style&index=0&id=25ae76aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae76aa",
  null
  
)

export default component.exports